import NoAccessModal from './NoAccessModal.mjs';

export default function AccessBlocked() {
  return (
    <>
      <div className="alert alert-info" role="alert">
        <div className="d-flex gap-2 align-items-center flex-wrap">
          <div className="text-wrap d-flex gap-2 align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="currentColor" />
            </svg>
            <p className="mb-0">An online account is required to redeem these perks.</p>
          </div>
          <div className="d-flex gap-3 ms-auto text-wrap">
            <a href="https://windcreekcasino.com/signup" target="_blank" class="btn btn-primary ">Join Now</a>
            <button className="btn btn-outline-primary" role="button" id="no-access" data-bs-target="#no-access-modal" data-bs-toggle="modal">Learn More</button>
          </div>
        </div>
      </div>
      <NoAccessModal />
    </>
  )
}
